module.exports = __webpack_public_path__ + "static/media/region.df7c315b.svg";